
import { createSlice } from '@reduxjs/toolkit'
import { FCMTokenInsert,sendMessageBack } from '../api/ChatApi'

const initialState = {
    FCMData:[],
    msgdata:[],
    loading:false,
}

export const ChatSlice = createSlice({
  name: 'ChatSlice',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder.addCase(FCMTokenInsert.pending, (state, action) => {
        state.loading = true;

      })
      builder.addCase(FCMTokenInsert.fulfilled , (state, action) => {
        state.FCMData=action.payload;
        state.loading = false;
      })
      builder.addCase(FCMTokenInsert.rejected, (state, action) => {
        state.loading = false;
      
      })


      builder.addCase(sendMessageBack.pending, (state, action) => {
        state.loading = true;

      })
      builder.addCase(sendMessageBack.fulfilled , (state, action) => {
        state.msgdata=action.payload;
        state.loading = false;
      })
      builder.addCase(sendMessageBack.rejected, (state, action) => {
        state.loading = false;
      
      })
      
  },

})

 

export default ChatSlice.reducer